import type { StoreActionApi } from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

export type CustomSitesExtensionsState = {
	isInViewMode: boolean; // Defines if the extension is in view mode
	isInAutoFocusMode: boolean; // Defines if it should auto scroll to expanded card
	selectedExtensionLocalId: string | null; // In edit mode defines an active extension localId
	selectedToEditCardId: string | null; // In edit mode defines an active card id (selected on the extension and expanded on the config panel)
	selectedToRemoveCardId: string | null; // In edit mode defines an active card id that is about to be removed
};

const initialState: CustomSitesExtensionsState = {
	isInViewMode: true,
	isInAutoFocusMode: true,
	selectedExtensionLocalId: null,
	selectedToEditCardId: null,
	selectedToRemoveCardId: null,
};

// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const actions = {
	setIsInViewMode:
		(isInViewMode: boolean) =>
		({ setState }: StoreActionApi<CustomSitesExtensionsState>) => {
			setState({ isInViewMode });
		},
	setIsInAutoFocusMode:
		(isInAutoFocusMode: boolean) =>
		({ setState }: StoreActionApi<CustomSitesExtensionsState>) => {
			setState({ isInAutoFocusMode });
		},
	setSelectedExtensionLocalId:
		(extensionLocalId: string | null) =>
		({ getState, setState }: StoreActionApi<CustomSitesExtensionsState>) => {
			if (getState().isInViewMode) {
				return;
			}
			setState({ selectedExtensionLocalId: extensionLocalId });
		},
	setSelectedToEditCardId:
		(cardId: string | null) =>
		({ getState, setState }: StoreActionApi<CustomSitesExtensionsState>) => {
			if (getState().isInViewMode) {
				return;
			}
			setState({ selectedToEditCardId: cardId });
		},
	setSelectedToRemoveCardId:
		(cardId: string | null) =>
		({ getState, setState }: StoreActionApi<CustomSitesExtensionsState>) => {
			if (getState().isInViewMode) {
				return;
			}
			setState({ selectedToRemoveCardId: cardId });
		},
};

const CustomSitesExtensionsStore = createStore({
	initialState,
	actions,
	name: 'CustomSitesExtensionsStore',
});

export const useCustomSitesExtensions = createHook(CustomSitesExtensionsStore);
export const useCustomSitesExtensionsActions = createActionsHook(CustomSitesExtensionsStore);
